import React, { type ReactNode } from 'react';
import { Stack, xcss } from '@atlaskit/primitives';
import { LeftSidebar } from '@atlassian/jira-navigation-system';
import { useSideNavCollapsedState } from '@atlassian/jira-navigation-system/src/v4';

type Props = {
	children: ReactNode;
};

export const SidebarContainer = ({ children }: Props) => {
	const collapsedState = useSideNavCollapsedState();

	return (
		<LeftSidebar collapsedState={collapsedState ? 'collapsed' : 'expanded'}>
			<Stack space="space.100" xcss={containerStyles}>
				{children}
			</Stack>
		</LeftSidebar>
	);
};

const containerStyles = xcss({
	padding: 'space.200',
});
